/** Phone Number Input (intl-tel-input) **/
// Every [data-phone-input] field gets the flag/country-code picker, with the
// US as the default country (this is a US trucking office). The widget only
// shows a national-format string in the visible textbox — the dial code
// lives in the flag button, not the input's own value — so anything reading
// the raw field value (a form submit, a Quick Add AJAX payload) needs the
// full E.164 number synced into it first, via syncPhoneInputsIn() below.
function initPhoneInputs($root) {
    if (typeof window.intlTelInput !== "function") return;
    $root.find("[data-phone-input]").each(function () {
        if (this.iti) return;
        window.intlTelInput(this, {
            initialCountry: "us",
            separateDialCode: true,
            strictMode: true,
        });
    });
}

function syncPhoneInputsIn($root) {
    if (typeof window.intlTelInput !== "function") return;
    $root.find("[data-phone-input]").each(function () {
        var iti = this.iti;
        if (!iti || !jQuery.trim(this.value)) return;
        var utils = window.intlTelInput.utils;
        var formatted = iti.getNumber(utils ? utils.numberFormat.E164 : undefined);
        if (formatted) this.value = formatted;
    });
}

jQuery(function () {
    initPhoneInputs(jQuery(document));
});

// Forms submit as a plain POST (load track pages) or get read into an AJAX
// payload right as the submit/click fires (Quick Add) — both cases need the
// synced value in place before that read happens, so this has to run first.
jQuery(document).on("submit", "form", function () {
    syncPhoneInputsIn(jQuery(this));
});

/** Places Autocomplete **/
// Builds a clean "address, city, state zip, country" label from Nominatim's
// structured address fields — county/township/state-district are deliberately
// left out, they're overkill for a pickup/delivery address.
function _placesAcLabel(r) {
    var a = r.address || {};
    var parts = [];
    var street = [a.house_number, a.road].filter(Boolean).join(" ");
    if (street) parts.push(street);
    // Nominatim tags some townships as "town" (e.g. "Canton Township, MI")
    // rather than county — catch those here too, not just the county field.
    var city = a.city || a.town || a.village || a.hamlet || a.suburb;
    if (city && !/\btownship\b/i.test(city)) parts.push(city);
    if (a.state) parts.push(a.state);
    if (a.postcode) parts.push(a.postcode);
    if (a.country) parts.push(a.country);
    return parts.length ? parts.join(", ") : r.display_name;
}

function initPlacesAutocomplete($root) {
    $root.find("[data-places-autocomplete]").each(function (i) {
        var $input = jQuery(this);
        if ($input.data("placesInit")) return;
        $input.data("placesInit", true);

        var $wrap = $input.closest(".col-12");
        $wrap.css("position", "relative");
        var $list = jQuery('<ul class="places-ac-list"></ul>').appendTo($wrap);
        var timer;

        function clearList() {
            $list.hide().empty();
        }

        $input.attr("autocomplete", "off").on("input", function () {
            var val = jQuery.trim(jQuery(this).val());
            clearTimeout(timer);
            $wrap
                .find("[data-stop-field='lat'], [data-stop-field='lng']")
                .val("");
            if (val.length < 3) {
                clearList();
                return;
            }

            timer = setTimeout(function () {
                fetch(
                    "https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=6&q=" +
                        encodeURIComponent(val),
                )
                    .then(function (r) {
                        return r.json();
                    })
                    .then(function (results) {
                        clearList();
                        results
                            .filter(function (r) {
                                // Township/county/state boundary hits aren't
                                // useful pickup/delivery addresses — only
                                // surface actual places (cities, roads, buildings).
                                return (
                                    !(r.class === "boundary" && r.type === "administrative") &&
                                    r.type !== "county" &&
                                    r.type !== "state"
                                );
                            })
                            .forEach(function (r) {
                                var label = _placesAcLabel(r);
                                jQuery("<li></li>")
                                    .text(label)
                                    .on("mousedown", function (e) {
                                        e.preventDefault();
                                        $input.val(label);
                                        $wrap
                                            .find("[data-stop-field='lat']")
                                            .val(r.lat);
                                        $wrap
                                            .find("[data-stop-field='lng']")
                                            .val(r.lon);
                                        clearList();
                                    })
                                    .appendTo($list);
                            });
                        if ($list.children().length) $list.show();
                    })
                    .catch(clearList);
            }, 350);
        });

        $input.on("blur", function () {
            setTimeout(clearList, 150);
        });
    });
}

jQuery(document).ready(function () {
    initPlacesAutocomplete(jQuery(document));
});

// Mark the direct parent of each DataTable so CSS can apply horizontal scroll on mobile
jQuery(document).on('init.dt', function (e, settings) {
    jQuery(settings.nTable).parent().addClass('dt-table-cell');
});

/** Functions  **/
var map = null;
var mapMobile = null;

function isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
}

function initMap() {
    map = new google.maps.Map(jQuery("#workspace-map")[0], {
        center: { lat: 39.8283, lng: -98.5795 },
        zoom: 5,
        disableDefaultUI: true,
    });

    var $mobileMapEl = jQuery("#workspace-map-mobile");
    if ($mobileMapEl.length) {
        mapMobile = new google.maps.Map($mobileMapEl[0], {
            center: { lat: 39.8283, lng: -98.5795 },
            zoom: 5,
            disableDefaultUI: true,
        });
    }

    jQuery(".js-zoomin").on("click", function () {
        map.setZoom(map.getZoom() + 1);
    });

    jQuery(".js-zoomout").on("click", function () {
        map.setZoom(map.getZoom() - 1);
    });

    var isRoadmap = true;
    jQuery(".js-layers").on("click", function () {
        isRoadmap = !isRoadmap;
        map.setMapTypeId(isRoadmap ? "roadmap" : "satellite");
        jQuery(this).toggleClass("is-active", !isRoadmap);
    });

    jQuery(".js-fullscreen").on("click", function () {
        var wrapper = jQuery(".workspace__map")[0];
        if (!document.fullscreenElement) {
            wrapper.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    });

    jQuery(document).on("fullscreenchange", function () {
        google.maps.event.trigger(map, "resize");
    });

    loadMapPins();
    if (!window._dashboardMapPinTimer) {
        window._dashboardMapPinTimer = setInterval(function () {
            if (!document.hidden) loadMapPins();
        }, 8000);
    }
    if (!window._dashboardLiveLoadTimer) {
        window._dashboardLiveLoadTimer = setInterval(function () {
            if (!document.hidden) refreshActiveLoadData();
        }, 8000);
    }

    // Backgrounded/inactive tabs skip the polls above entirely rather than just
    // running them uselessly — cuts DB load from multiple open dashboard tabs
    // stacking up polls nobody's looking at. Refresh immediately on refocus so
    // the view isn't stale for up to 8s after coming back.
    if (!window._dashboardVisibilityGuardAdded) {
        window._dashboardVisibilityGuardAdded = true;
        document.addEventListener("visibilitychange", function () {
            if (!document.hidden) {
                loadMapPins();
                refreshActiveLoadData();
            }
        });
    }
}

/** Notice System **/
function showAppNotice(message, type) {
    type = type || "success";
    var $notices = jQuery("#app-notices");
    if (!$notices.length) return;

    var $notice = jQuery(
        '<div class="app-notice app-notice--' + type + '" role="alert"></div>',
    ).text(message);
    $notices.append($notice);

    setTimeout(function () {
        $notice.addClass("app-notice--hide");
        setTimeout(function () {
            $notice.remove();
        }, 400);
    }, 4000);
}

/** Stop card helpers **/
var interimTypeLabels = {
    additional_pickup: "Additional Pickup",
    recovery: "Recovery",
};

function interimTypeLabel(val) {
    return interimTypeLabels[val] || "Interim Stop";
}

function updateInterimStopTitle($card) {
    var $sel = $card.find("[data-interim-type-select]");
    if (!$sel.length) return;
    $card.find("[data-stop-title]").text(interimTypeLabel($sel.val()));
}

jQuery(document).on("change", "[data-interim-type-select]", function () {
    updateInterimStopTitle(jQuery(this).closest("[data-office-stop-card]"));
});

// FCFS window end only applies to FCFS stops — hidden (and cleared, so a
// stale value isn't submitted) for APT.
function updateAppointmentTypeFields($card) {
    var $sel = $card.find("[data-appointment-type-select]");
    if (!$sel.length) return;
    var isFcfs = $sel.val() === "fcfs";
    var $wrap = $card.find("[data-fcfs-end-wrap]");
    $wrap.prop("hidden", !isFcfs);
    if (!isFcfs) $wrap.find("input").val("");
}

jQuery(document).on("change", "[data-appointment-type-select]", function () {
    updateAppointmentTypeFields(jQuery(this).closest("[data-office-stop-card]"));
});

function assignStopNames($form) {
    jQuery("[data-office-stop-card]", $form).each(function (i) {
        var $card = jQuery(this);
        $card.find("[data-stop-field]").each(function () {
            jQuery(this).attr(
                "name",
                "stops[" + i + "][" + jQuery(this).data("stop-field") + "]",
            );
        });
        $card
            .find("[data-office-stop-kind]")
            .attr("name", "stops[" + i + "][stop_kind]");
    });
}

jQuery(document).on("click", "[data-office-add-stop]", function () {
    var tpl = document.getElementById("stop-interim-template");
    if (!tpl) return;
    var $card = jQuery(tpl.content.cloneNode(true));
    var $anchor = jQuery("[data-office-stop-card][data-stop-position='last']");
    $anchor.before($card);

    var $newCard = $anchor.prev("[data-office-stop-card]");
    initPlacesAutocomplete($newCard);

    $newCard[0].scrollIntoView({ behavior: "smooth", block: "center" });
    $newCard.addClass("is-new");
    $newCard.one("animationend", function () {
        jQuery(this).removeClass("is-new");
    });
});

jQuery(document).on("click", "[data-office-remove-stop]", function () {
    jQuery(this).closest("[data-office-stop-card]").remove();
});

/** Template loader **/
function fillStopCard($card, stop) {
    $card.find("[data-stop-field]").each(function () {
        var field = jQuery(this).data("stop-field");
        var val = stop[field];

        if (field === "custom_events_text") {
            try {
                val = JSON.parse(stop.custom_events || "[]").join(", ");
            } catch (e) {
                val = "";
            }
        }
        if (val === undefined || val === null) val = "";

        if (jQuery(this).is(":checkbox")) {
            jQuery(this).prop("checked", val == 1);
        } else {
            jQuery(this).val(val);
        }
    });
    $card.find("[data-office-stop-kind]").val(stop.stop_kind || "");
    var $apptSel = $card.find("[data-appointment-type-select]");
    if ($apptSel.length && !$apptSel.val()) $apptSel.val("appt");
    if (stop.scheduled_time_end) {
        $card
            .find("[data-stop-field='scheduled_time_end']")
            .val(String(stop.scheduled_time_end).substring(0, 5));
    }
    updateInterimStopTitle($card);
    updateAppointmentTypeFields($card);
}

function fillFormFromTemplate(res) {
    var lt = res.load_track;
    var stops = res.stops || [];
    var $form = jQuery("#loadTrackForm");
    var skip = [
        "action",
        "_token",
        "id",
        "save_as_template",
        "is_template",
        "driver_id",
        "created_by",
        "created_at",
        "updated_at",
    ];

    jQuery.each(lt, function (key, val) {
        if (skip.indexOf(key) !== -1) return;
        var $inputs = $form.find("[name='" + key + "']");
        if (!$inputs.length) return;
        if ($inputs.first().is("[type='radio']")) {
            $form
                .find("[name='" + key + "'][value='" + val + "']")
                .prop("checked", true);
        } else if ($inputs.first().is(":checkbox")) {
            $inputs.prop("checked", val == 1);
        } else {
            $inputs.val(val !== null ? val : "");
        }
    });

    if (stops.length) {
        var $container = jQuery("[data-office-stops-container]", $form);
        var $firstCard = $container.find("[data-office-stop-card]").first();
        var $lastCard = $container.find(
            "[data-office-stop-card][data-stop-position='last']",
        );

        // Remove interim stops
        $container
            .find("[data-office-stop-card]")
            .not($firstCard)
            .not($lastCard)
            .remove();

        fillStopCard($firstCard, stops[0]);
        fillStopCard($lastCard, stops[stops.length - 1]);

        var tpl = document.getElementById("stop-interim-template");
        if (tpl) {
            jQuery.each(stops.slice(1, -1), function (_, stop) {
                var $clone = jQuery(tpl.innerHTML);
                fillStopCard($clone.filter("[data-office-stop-card]"), stop);
                $lastCard.before($clone);
            });
        }
    }

    togglePhoneUserField($form);
    showAppNotice("Template loaded.", "success");
}

jQuery(document).on("change", "#templateSelect", function () {
    var id = jQuery(this).val();
    var token = jQuery("#loadTrackForm [name='_token']").val();
    if (!id) return;

    jQuery.ajax({
        url: "/ajax",
        method: "POST",
        data: { action: "load_tracks_get_template", id: id, _token: token },
        dataType: "json",
        success: function (res) {
            if (res.success) {
                fillFormFromTemplate(res);
            } else {
                showAppNotice(
                    res.message || "Could not load template.",
                    "error",
                );
            }
        },
        error: function () {
            showAppNotice("A server error occurred.", "error");
        },
    });
});

/** Shipper autofill **/
jQuery(document).on("change", "#shipperSelect", function () {
    var code = jQuery(this).find(":selected").data("shipper-code") || "";
    jQuery("#shipperIdentifier").val(code);
});

function togglePhoneUserField($form) {
    var isPhone = $form.find("[name='tracking_type']").val() === "Phone";
    var $field = $form.find("[data-phone-user-field]");
    var $select = $field.find("[name='driver_id']");
    $field.prop("hidden", !isPhone);
    $select.prop("required", isPhone);
    if (!isPhone) {
        $select.val("");
    }
}

jQuery(document).on(
    "change",
    "#loadTrackForm [name='tracking_type']",
    function () {
        togglePhoneUserField(jQuery(this).closest("form"));
    },
);

jQuery(document).on("change", "#loadTrackForm [name='driver_id']", function () {
    var $selected = jQuery(this).find(":selected");
    var $form = jQuery(this).closest("form");

    [
        ["driver-name", "driver_name"],
        ["driver-phone-1", "driver_phone_1"],
        ["driver-phone-2", "driver_phone_2"],
    ].forEach(function (pair) {
        var value = $selected.data(pair[0]) || "";
        var $input = $form.find("[name='" + pair[1] + "']");
        var current = jQuery.trim($input.val() || "");
        var wasAutofilled = $input.data("mobileDriverAutofilled") === true;

        if (value && (!current || wasAutofilled)) {
            $input.val(value).data("mobileDriverAutofilled", true);
        } else if (!value && wasAutofilled) {
            $input.val("").data("mobileDriverAutofilled", false);
        }
    });
});

jQuery(document).on(
    "input",
    "#loadTrackForm [name='driver_name'], #loadTrackForm [name='driver_phone_1'], #loadTrackForm [name='driver_phone_2']",
    function () {
        jQuery(this).data("mobileDriverAutofilled", false);
    },
);

jQuery(function () {
    jQuery("#loadTrackForm").each(function () {
        togglePhoneUserField(jQuery(this));
    });
});

/** Quick Add (Driver / Shipper / Dispatcher) **/
var quickAddConfig = {
    dispatcher: {
        action: "dispatchers_store",
        label: "Dispatcher",
        optionLabel: function (data) {
            return data.name + " (" + data.email + ")";
        },
    },
    driver: {
        action: "drivers_store",
        label: "Driver",
        optionLabel: function (data) {
            return data.name + (data.phone_1 ? " — " + data.phone_1 : "");
        },
        optionAttrs: function (data) {
            return {
                "data-driver-name": data.name,
                "data-driver-phone-1": data.phone_1 || "",
            };
        },
    },
    shipper: {
        action: "shippers_store",
        label: "Shipper",
        optionLabel: function (data) {
            return (
                data.name + (data.shipper_code ? " - " + data.shipper_code : "")
            );
        },
        optionAttrs: function (data) {
            return { "data-shipper-code": data.shipper_code || "" };
        },
    },
};

function closeQuickAddSidebar() {
    var $sidebar = jQuery("[data-quick-add-sidebar]");
    $sidebar.prop("hidden", true);
    $sidebar.find("[data-quick-add-panel]").prop("hidden", true);
    $sidebar.find("[data-quick-add-field]").each(function () {
        if (this.iti) this.iti.setNumber("");
        else this.value = "";
    });
}

// Pulls the actual message out of a failed AJAX response (JSON body, or
// raw text as a last resort) instead of showing a generic error.
function quickAddErrorMessage(jqXHR, fallback) {
    if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message) {
        return jqXHR.responseJSON.message;
    }
    if (jqXHR && jqXHR.responseText) {
        try {
            var parsed = JSON.parse(jqXHR.responseText);
            if (parsed && parsed.message) return parsed.message;
        } catch (e) {}
        var text = jQuery.trim(jqXHR.responseText);
        if (text) return text.length > 200 ? text.substring(0, 200) + "…" : text;
    }
    return fallback;
}

jQuery(document).on("click", "[data-quick-add-toggle]", function () {
    var key = jQuery(this).data("quickAddToggle");
    var cfg = quickAddConfig[key];
    if (!cfg) return;

    var $sidebar = jQuery("[data-quick-add-sidebar]");
    $sidebar.find("[data-quick-add-panel]").prop("hidden", true);
    var $panel = $sidebar.find('[data-quick-add-panel="' + key + '"]').prop("hidden", false);
    $sidebar.find("[data-quick-add-sidebar-title]").text("Quick Add " + cfg.label);
    $sidebar.prop("hidden", false);

    // Initializing intl-tel-input while the panel is still hidden leaves its
    // flag-button width miscalculated (can't measure a display:none
    // element) — wait until it's actually visible.
    initPhoneInputs($panel);
});

jQuery(document).on(
    "click",
    "[data-quick-add-close], [data-quick-add-cancel]",
    function () {
        closeQuickAddSidebar();
    },
);

jQuery(document).on("click", "[data-quick-add-submit]", function () {
    var key = jQuery(this).data("quickAddSubmit");
    var cfg = quickAddConfig[key];
    if (!cfg) return;

    var $btn = jQuery(this);
    var $panel = jQuery('[data-quick-add-panel="' + key + '"]');
    var $fields = $panel.find("[data-quick-add-field]");

    syncPhoneInputsIn($panel);

    var $invalid = $fields.filter(function () {
        return !this.checkValidity();
    });
    if ($invalid.length) {
        $invalid.first()[0].reportValidity();
        return;
    }

    var data = {
        action: cfg.action,
        _token: jQuery('meta[name="csrf-token"]').attr("content") || "",
        is_active: 1,
    };
    $fields.each(function () {
        data[jQuery(this).data("quickAddField")] = jQuery(this).val();
    });

    $btn.prop("disabled", true);

    jQuery.ajax({
        url: "/ajax",
        method: "POST",
        data: data,
        dataType: "json",
        success: function (res) {
            $btn.prop("disabled", false);
            if (!res.success) {
                showAppNotice(res.message || "Could not create record.", "error");
                return;
            }

            var $select = jQuery('[data-quick-add-select="' + key + '"]');
            var $option = jQuery("<option></option>")
                .val(res.id)
                .text(cfg.optionLabel(res));
            if (cfg.optionAttrs) {
                jQuery.each(cfg.optionAttrs(res), function (attr, val) {
                    $option.attr(attr, val);
                });
            }
            $select.append($option);
            $select.val(res.id).trigger("change");

            closeQuickAddSidebar();
            showAppNotice(cfg.label + " created.", "success");
        },
        error: function (jqXHR) {
            $btn.prop("disabled", false);
            showAppNotice(
                quickAddErrorMessage(jqXHR, "A server error occurred."),
                "error",
            );
        },
    });
});

/** AJAX Forms **/
jQuery(document).on("submit", "form[action='/ajax']", function (e) {
    e.preventDefault();

    var $form = jQuery(this);
    var $btn = $form.find("[type='submit']");

    assignStopNames($form);
    $btn.prop("disabled", true);

    jQuery.ajax({
        url: "/ajax",
        method: "POST",
        data: $form.serialize(),
        dataType: "json",
        success: function (res) {
            if (res.success) {
                if (res.redirect) {
                    window.location.href = res.redirect;
                } else {
                    if (res.message) showAppNotice(res.message, "success");
                    $btn.prop("disabled", false);
                }
            } else {
                showAppNotice(res.message || "An error occurred.", "error");
                $btn.prop("disabled", false);
            }
        },
        error: function () {
            showAppNotice(
                "A server error occurred. Please try again.",
                "error",
            );
            $btn.prop("disabled", false);
        },
    });
});

/** Dashboard **/
jQuery(document).ready(function ($) {
    var $dashboard = $("[data-dashboard-root]");
    if (!$dashboard.length) {
        return;
    }

    var $filterForm = $("[data-dashboard-filter-form]");
    var $searchInput = $("[data-search-input='desktop']");
    var csrfToken = $dashboard.data("csrfToken");
    var ajaxUrl = $dashboard.data("ajaxUrl");
    var pendingRequest = null;
    var searchTimer = null;

    function currentFilters() {
        return {
            status:
                $filterForm.find("input[name='status']").val() || "tracking",
            shipper_id:
                $filterForm.find("select[name='shipper_id']").val() || "",
            dispatcher_id:
                $filterForm.find("select[name='dispatcher_id']").val() || "",
            q: $.trim($searchInput.val() || ""),
            date_from: $filterForm.find("[data-date-filter-from]").val() || "",
            date_to: $filterForm.find("[data-date-filter-to]").val() || "",
        };
    }

    function buildDashboardUrl(filters, overrides) {
        var params = $.extend({}, filters, overrides || {});
        var searchParams = new URLSearchParams();

        if (params.status) {
            searchParams.set("status", params.status);
        }

        if (params.shipper_id) {
            searchParams.set("shipper_id", params.shipper_id);
        }

        if (params.dispatcher_id) {
            searchParams.set("dispatcher_id", params.dispatcher_id);
        }

        if (params.q) {
            searchParams.set("q", params.q);
        }

        if (params.date_from) {
            searchParams.set("date_from", params.date_from);
        }

        if (params.date_to) {
            searchParams.set("date_to", params.date_to);
        }

        var queryString = searchParams.toString();
        return "/dashboard" + (queryString ? "?" + queryString : "");
    }

    function syncDashboardLinks(filters) {
        $filterForm.find("[data-dashboard-search-query]").val(filters.q || "");
        $("[data-dashboard-tab]").each(function () {
            var $tab = $(this);
            var tabStatus = $tab.data("dashboardTab");
            $tab.attr(
                "href",
                buildDashboardUrl(filters, { status: tabStatus }),
            );
            $tab.toggleClass("is-active", filters.status === tabStatus);
        });
    }

    function refreshDashboard() {
        var filters = currentFilters();

        if (pendingRequest) {
            pendingRequest.abort();
        }

        pendingRequest = $.ajax({
            url: ajaxUrl,
            method: "POST",
            dataType: "json",
            data: {
                action: "dashboard_loads_search",
                _token: csrfToken,
                status: filters.status,
                shipper_id: filters.shipper_id,
                dispatcher_id: filters.dispatcher_id,
                q: filters.q,
                date_from: filters.date_from,
                date_to: filters.date_to,
            },
            success: function (res) {
                if (!res.success) {
                    showAppNotice(
                        res.message || "Could not refresh dashboard.",
                        "error",
                    );
                    return;
                }

                $("[data-dashboard-status-bar]").replaceWith(
                    res.status_bar_html,
                );
                $("[data-dashboard-sidebar]").replaceWith(res.sidebar_html);
                $("[data-dashboard-date-filter]").text(
                    res.date_range_label || "No scheduled dates",
                );
                syncDashboardLinks(res.filters || filters);
                loadMapPins();

                if (res.url) {
                    window.history.replaceState({}, "", res.url);
                }
            },
            error: function (xhr, status) {
                if (status === "abort") {
                    return;
                }

                showAppNotice(
                    "A server error occurred. Please try again.",
                    "error",
                );
            },
            complete: function () {
                pendingRequest = null;
            },
        });
    }

    if ($.fn.select2) {
        $filterForm.find(".js-dashboard-select").each(function () {
            var $select = $(this);
            $select.select2({
                width: "220px",
                allowClear: true,
                placeholder: $select.data("placeholder"),
            });
        });
    }

    if (typeof flatpickr !== "undefined") {
        var $dateFilter = $filterForm.find("[data-date-filter]");
        var $triggerBtn = $dateFilter.find("[data-date-filter-trigger]");
        var $fromInput = $dateFilter.find("[data-date-filter-from]");
        var $toInput = $dateFilter.find("[data-date-filter-to]");
        var $label = $dateFilter.find("[data-date-filter-label]");

        var initialDates = [];
        if ($fromInput.val()) {
            initialDates.push($fromInput.val());
        }
        if ($toInput.val()) {
            initialDates.push($toInput.val());
        }

        var datePicker = flatpickr($triggerBtn[0], {
            mode: "range",
            dateFormat: "Y-m-d",
            defaultDate: initialDates.length ? initialDates : null,
            onChange: function (selectedDates) {
                if (selectedDates.length === 0) {
                    $fromInput.val("");
                    $toInput.val("");
                    $label.text("Date Range");
                    $dateFilter.removeClass("is-active");
                    refreshDashboard();
                } else if (selectedDates.length === 2) {
                    var from = flatpickr.formatDate(selectedDates[0], "Y-m-d");
                    var to = flatpickr.formatDate(selectedDates[1], "Y-m-d");
                    $fromInput.val(from);
                    $toInput.val(to);
                    $label.text(
                        flatpickr.formatDate(selectedDates[0], "M j, Y") +
                            " – " +
                            flatpickr.formatDate(selectedDates[1], "M j, Y"),
                    );
                    $dateFilter.addClass("is-active");
                    refreshDashboard();
                }
            },
        });

        $dateFilter.find("[data-date-filter-clear]").on("click", function () {
            datePicker.clear();
        });
    }

    syncDashboardLinks(currentFilters());

    $filterForm.on("submit", function (event) {
        event.preventDefault();
        refreshDashboard();
    });

    $filterForm.on("change", "select", function () {
        refreshDashboard();
    });

    $searchInput.on("input", function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(refreshDashboard, 250);
    });

    $(document).on("click", "[data-dashboard-tab]", function (event) {
        event.preventDefault();
        var status = $(this).data("dashboardTab");
        $filterForm.find("input[name='status']").val(status);
        refreshDashboard();
    });
});

/** Delete Buttons **/
jQuery(document).on("click", "[data-ajax-delete]", function () {
    var $btn = jQuery(this);
    var action = $btn.data("ajax-delete");
    var id = $btn.data("id");
    var token = $btn.data("token");
    var label = $btn.data("label") || "this record";

    if (!confirm("Are you sure you want to delete " + label + "?")) return;

    $btn.prop("disabled", true);

    jQuery.ajax({
        url: "/ajax",
        method: "POST",
        data: { action: action, id: id, _token: token },
        dataType: "json",
        success: function (res) {
            if (res.success) {
                var $table = $btn.closest("table");
                if (
                    $table.length &&
                    jQuery.fn.DataTable &&
                    jQuery.fn.DataTable.isDataTable($table)
                ) {
                    // Server-side DataTables tracks its own paging/record counts —
                    // removing the <tr> by hand would desync "Showing X of Y" and
                    // page navigation, so ask it to re-fetch the current page instead.
                    $table.DataTable().ajax.reload(null, false);
                } else {
                    var $row = $btn.closest("tr");
                    $row.fadeOut(300, function () {
                        $row.remove();
                    });
                }
                showAppNotice(
                    res.message || "Deleted successfully.",
                    "success",
                );
            } else {
                showAppNotice(res.message || "Could not delete.", "error");
                $btn.prop("disabled", false);
            }
        },
        error: function () {
            showAppNotice("A server error occurred.", "error");
            $btn.prop("disabled", false);
        },
    });
});

/** Load Card Popup **/
jQuery(document).on("click", ".load-card-popup__header", function (e) {
    if (
        jQuery(e.target).closest("[data-popup-minimize], [data-popup-close]")
            .length
    )
        return;
    var $popup = jQuery(this).closest(".load-card-popup");
    var $sheet = $popup.closest("[data-mobile-sheet]");
    if ($sheet.length) {
        if ($sheet.hasClass("is-minimized")) {
            expandMobileSheet();
        }
        return;
    }
    var isOpen = $popup.hasClass("is-opened");
    jQuery(".workspace__map-loads .load-card-popup").removeClass("is-opened");
    if (!isOpen) {
        $popup.addClass("is-opened");
    }
});

jQuery(document).on("click", "[data-popup-minimize]", function (e) {
    e.preventDefault();
    var $popup = jQuery(this).closest(".load-card-popup");
    var $sheet = $popup.closest("[data-mobile-sheet]");
    if ($sheet.length) {
        if ($sheet.hasClass("is-minimized")) {
            expandMobileSheet();
        } else {
            minimizeMobileSheet();
        }
        return;
    }
    $popup.removeClass("is-opened");
});

jQuery(document).on("click", "[data-popup-close]", function (e) {
    e.preventDefault();
    var $popup = jQuery(this).closest(".load-card-popup");
    var loadId = $popup.data("popupLoadId");
    var $sheet = $popup.closest("[data-mobile-sheet]");
    removeLoadFromMap(loadId);
    jQuery("[data-load-id='" + loadId + "']").removeClass("is-active");
    $popup.remove();
    if ($sheet.length) {
        $sheet.removeClass("is-open is-minimized").removeData("activeLoadId");
        jQuery("[data-mobile-sheet-backdrop]").removeClass("is-open");
    }
});

jQuery(document).on("click", "[data-popup-toggle]", function () {
    var $btn = jQuery(this);
    var $section = $btn.closest(".popup-section");
    var $popup = $section.closest(".load-card-popup");
    var isActive = $section.hasClass("popup-section--active");
    $popup.find(".popup-section").removeClass("popup-section--active");
    $popup.find("[data-popup-toggle]").attr("aria-expanded", "false");
    if (!isActive) {
        $section.addClass("popup-section--active");
        $btn.attr("aria-expanded", "true");
    }
});

jQuery(document).on("click", "[data-popup-calculate-eta]", function (e) {
    e.preventDefault();
    var $btn = jQuery(this);
    if ($btn.prop("disabled")) return;

    var $popup = $btn.closest(".load-card-popup");
    var loadId = $popup.data("popupLoadId");
    if (!loadId) return;

    var csrfToken = jQuery("[data-dashboard-root]").data("csrfToken");
    var ajaxUrl = jQuery("[data-dashboard-root]").data("ajaxUrl");
    var originalText = $btn.text();

    $btn.prop("disabled", true).text("Calculating…");

    jQuery.ajax({
        url: ajaxUrl,
        method: "POST",
        dataType: "json",
        data: {
            action: "load_track_eta",
            id: loadId,
            _token: csrfToken,
        },
        success: function (res) {
            $btn.prop("disabled", false).text(originalText);
            if (!res.success) {
                showAppNotice(res.message || "Could not calculate ETA.", "error");
                return;
            }
            $popup.find("[data-popup-eta-value]").text(res.eta_label);
            $popup
                .find("[data-popup-eta-delay]")
                .text(res.delay_label)
                .css("color", res.delay_color);
            $popup.find("[data-popup-eta-updated]").text(res.updated_label);

            var isLate = res.delay_color === "#ef4444";
            $popup
                .find("[data-popup-eta-alert-text]")
                .text("Running " + res.delay_label);
            $popup.find("[data-popup-eta-alert]").prop("hidden", !isLate);
        },
        error: function () {
            $btn.prop("disabled", false).text(originalText);
            showAppNotice("A server error occurred calculating ETA.", "error");
        },
    });
});

jQuery(document).on("click", "[data-share-url]", function () {
    var shareUrl = window.location.origin + jQuery(this).data("shareUrl");
    if (!navigator.clipboard) {
        showAppNotice("Copy not supported in this browser.", "error");
        return;
    }
    navigator.clipboard.writeText(shareUrl).then(
        function () {
            showAppNotice("Tracking URL copied to clipboard!", "success");
        },
        function () {
            showAppNotice("Could not copy URL.", "error");
        },
    );
});

jQuery(document).on("click", "[data-full-view-url]", function () {
    var url = jQuery(this).data("fullViewUrl");
    if (url) {
        window.open(url, "_blank");
    }
});

// Accept POD — same action_load_tracks_end() the full load-track view's
// "Accept POD" button uses, just reachable straight from the dashboard popup.
// (The track itself already ended when the driver submitted the POD.)
jQuery(document).on("click", "[data-accept-pod]", function () {
    var $btn = jQuery(this);
    var loadId = $btn.data("loadId");
    var loadLabel = $btn.data("loadLabel") || "this load";
    if (!loadId) return;

    if (!confirm('Accept the POD for "' + loadLabel + '"?')) return;

    var $dashboard = jQuery("[data-dashboard-root]");
    $btn.prop("disabled", true);

    jQuery.ajax({
        url: $dashboard.data("ajaxUrl") || "/ajax",
        method: "POST",
        dataType: "json",
        data: {
            action: "load_tracks_end",
            id: loadId,
            _token: $dashboard.data("csrfToken"),
        },
        success: function (res) {
            if (res.success) {
                showAppNotice(
                    "POD accepted for " + loadLabel + ".",
                    "success",
                );
                window.location.reload();
            } else {
                showAppNotice(res.message || "Could not accept POD.", "error");
                $btn.prop("disabled", false);
            }
        },
        error: function () {
            showAppNotice("A server error occurred.", "error");
            $btn.prop("disabled", false);
        },
    });
});

/** Multi-map helpers — draw overlays on every active Google Map instance
 *  (desktop + mobile) so tracking data stays in sync across both views. **/
function _activeMaps() {
    return [map, mapMobile].filter(Boolean);
}

function _multiMarker(options) {
    var _markers = _activeMaps().map(function (targetMap) {
        return new google.maps.Marker(
            Object.assign({}, options, { map: targetMap }),
        );
    });
    return {
        setPosition: function (pos) {
            _markers.forEach(function (m) {
                m.setPosition(pos);
            });
        },
        getPosition: function () {
            return _markers.length ? _markers[0].getPosition() : null;
        },
        setMap: function (mapValue) {
            _markers.forEach(function (m) {
                m.setMap(mapValue);
            });
        },
        addListener: function (event, cb) {
            _markers.forEach(function (m) {
                m.addListener(event, cb);
            });
        },
    };
}

function _multiPolyline(options) {
    var _lines = _activeMaps().map(function (targetMap) {
        return new google.maps.Polyline(
            Object.assign({}, options, { map: targetMap }),
        );
    });
    return {
        setMap: function (mapValue) {
            _lines.forEach(function (l) {
                l.setMap(mapValue);
            });
        },
        getPath: function () {
            return _lines.length ? _lines[0].getPath() : new google.maps.MVCArray();
        },
    };
}

function _multiCircle(options) {
    var _circles = _activeMaps().map(function (targetMap) {
        return new google.maps.Circle(
            Object.assign({}, options, { map: targetMap }),
        );
    });
    return {
        setMap: function (mapValue) {
            _circles.forEach(function (c) {
                c.setMap(mapValue);
            });
        },
    };
}

/** Map Pin Icons **/
var _pinMarkers = {};

function _makeTruckIcon(color) {
    var svg = [
        '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="22" viewBox="0 0 34 22">',
        '<rect x="0" y="1" width="20" height="14" rx="2" fill="' +
            color +
            '" stroke="white" stroke-width="1.2"/>',
        '<path d="M20 4h5.5l6.5 8v6H20V4z" fill="' +
            color +
            '" stroke="white" stroke-width="1.2" stroke-linejoin="round"/>',
        '<rect x="21.5" y="6" width="5" height="5" rx="1" fill="rgba(255,255,255,0.38)"/>',
        '<circle cx="6"  cy="18" r="3" fill="white" stroke="' +
            color +
            '" stroke-width="1.5"/>',
        '<circle cx="25" cy="18" r="3" fill="white" stroke="' +
            color +
            '" stroke-width="1.5"/>',
        "</svg>",
    ].join("");
    return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
        scaledSize: new google.maps.Size(34, 22),
        anchor: new google.maps.Point(6, 18),
    };
}

function renderMapPins(pins) {
    if (!_activeMaps().length) return;

    var seenIds = {};

    pins.forEach(function (pin) {
        var key = String(pin.id);
        seenIds[key] = true;

        // Skip (and drop any existing) global pin if this load already has an
        // active overlay with its own vehicle marker, so we don't show both.
        if (_loadOverlays[key]) {
            if (_pinMarkers[key]) {
                _pinMarkers[key].setMap(null);
                delete _pinMarkers[key];
            }
            return;
        }

        var position = { lat: pin.lat, lng: pin.lng };

        // Update in place instead of destroying/recreating every marker on
        // every 8s poll — cheaper, and avoids the pin visibly flickering.
        if (_pinMarkers[key]) {
            _pinMarkers[key].setPosition(position);
            return;
        }

        var marker = _multiMarker({
            position: position,
            title: pin.label,
            icon: _makeTruckIcon(pin.color),
            zIndex: 5,
        });
        marker.addListener("click", function () {
            // The sidebar is rendered twice (desktop + mobile panes), so this
            // selector can match two DOM elements for the same load — only
            // trigger one, or the click handler fires twice and opens two popups.
            jQuery("[data-load-id='" + pin.id + "']").first().trigger("click");
        });
        _pinMarkers[key] = marker;
    });

    // Drop markers for loads that dropped out of this poll's pin list (ended,
    // filtered out, etc.) instead of leaving stale pins on the map.
    Object.keys(_pinMarkers).forEach(function (key) {
        if (!seenIds[key]) {
            _pinMarkers[key].setMap(null);
            delete _pinMarkers[key];
        }
    });
}

function updateActiveLoadVehicles(pins) {
    if (!_activeMaps().length) return;
    pins.forEach(function (pin) {
        var ov = _loadOverlays[String(pin.id)];
        if (!ov || !pin.lat || !pin.lng) return;

        var position = { lat: pin.lat, lng: pin.lng };
        if (ov.vehicle) {
            ov.vehicle.setPosition(position);
            return;
        }

        ov.vehicle = _multiMarker({
            position: position,
            title: "Last known position",
            icon: _makeTruckIcon(ov.color || "#3b82f6"),
            zIndex: 10,
        });
        ov.vehicle.addListener("click", function () {
            jQuery(
                '[data-popup-load-id="' +
                    pin.id +
                    '"] [data-popup-toggle="device"]',
            )
                .first()
                .trigger("click");
        });
    });
}

function loadMapPins() {
    if (!_activeMaps().length) return;
    var $dashboard = jQuery("[data-dashboard-root]");
    if (!$dashboard.length) return;
    var $form = jQuery("[data-dashboard-filter-form]");
    jQuery.ajax({
        url: $dashboard.data("ajaxUrl"),
        method: "POST",
        dataType: "json",
        data: {
            action: "dashboard_map_pins",
            _token: $dashboard.data("csrfToken"),
            status: $form.find("input[name='status']").val() || "tracking",
            shipper_id: $form.find("select[name='shipper_id']").val() || "",
            dispatcher_id:
                $form.find("select[name='dispatcher_id']").val() || "",
            q: jQuery.trim(jQuery("[data-search-input='desktop']").val() || ""),
            date_from: $form.find("[data-date-filter-from]").val() || "",
            date_to: $form.find("[data-date-filter-to]").val() || "",
        },
        success: function (res) {
            if (res.success) {
                renderMapPins(res.pins);
            }
        },
    });
}

/** Map Load Tracking **/
var _loadOverlays = {};
var _routeColorIndex = 0;
var _routeColors = [
    "#3b82f6",
    "#f97316",
    "#8b5cf6",
    "#14b8a6",
    "#ec4899",
    "#f59e0b",
];

function removeLoadFromMap(loadId) {
    var key = String(loadId);
    if (!_loadOverlays[key]) return;
    var ov = _loadOverlays[key];
    ov.markers.forEach(function (m) {
        m.setMap(null);
    });
    if (ov.polyline) ov.polyline.setMap(null);
    if (ov.trackPolyline) ov.trackPolyline.setMap(null);
    if (ov.vehicle) ov.vehicle.setMap(null);
    (ov.geofences || []).forEach(function (g) {
        g.setMap(null);
    });
    delete _loadOverlays[key];
    _fitAllActiveBounds();
}

function _fitAllActiveBounds() {
    if (!_activeMaps().length) return;
    var bounds = new google.maps.LatLngBounds();
    var hasAny = false;
    Object.keys(_loadOverlays).forEach(function (key) {
        var ov = _loadOverlays[key];
        // Always include the origin/destination stops so the default view
        // shows the whole route, not just wherever the truck currently is.
        ov.markers.forEach(function (m) {
            bounds.extend(m.getPosition());
            hasAny = true;
        });
        if (ov.vehicle) {
            bounds.extend(ov.vehicle.getPosition());
            hasAny = true;
        }
        if (ov.trackPolyline) {
            ov.trackPolyline.getPath().forEach(function (p) {
                bounds.extend(p);
                hasAny = true;
            });
        }
    });
    if (hasAny) {
        _activeMaps().forEach(function (m) {
            m.fitBounds(bounds, { padding: 60 });
        });
    }
}

function _formatLiveLocation(location) {
    if (!location || !location.lat || !location.lng) return "-";
    return (
        parseFloat(location.lat).toFixed(4) +
        " N, " +
        Math.abs(parseFloat(location.lng)).toFixed(4) +
        " W"
    );
}

function _parseUtcDate(value) {
    if (!value) return null;
    var normalized = String(value).trim().replace(" ", "T");
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(normalized)) {
        normalized += "Z";
    }
    var dt = new Date(normalized);
    return Number.isNaN(dt.getTime()) ? null : dt;
}

function _formatLivePing(recordedAt) {
    if (!recordedAt) return "No data";
    var dt = _parseUtcDate(recordedAt);
    if (!dt) return recordedAt;
    var seconds = Math.max(0, Math.floor((Date.now() - dt.getTime()) / 1000));
    if (seconds < 60) return seconds + " sec ago";
    var minutes = Math.floor(seconds / 60);
    if (minutes < 60) return minutes + " min ago";
    var hours = Math.floor(minutes / 60);
    if (hours < 24) return hours + " hr ago";
    return Math.floor(hours / 24) + " day ago";
}

function _popupNodes(loadId) {
    return jQuery(
        ".workspace__map-loads [data-popup-load-id='" +
            loadId +
            "'], .workspace-mobile__sheet-body [data-popup-load-id='" +
            loadId +
            "']",
    );
}

function _updatePopupLiveText(loadId, location) {
    var $popup = _popupNodes(loadId);
    if (!$popup.length || !location) return;

    var locationLabel = _formatLiveLocation(location);
    $popup
        .find("[data-popup-last-ping]")
        .text(_formatLivePing(location.recorded_at));
    $popup.find("[data-popup-location-label]").text(locationLabel);
    $popup
        .find("[data-popup-location-note]")
        .prop("hidden", false)
        .text(locationLabel);
    $popup.data("mapLocation", location);
}

function _updatePopupFraud(loadId, stationarySince) {
    var $content = _popupNodes(loadId).find("[data-popup-fraud-content]");
    if (!$content.length) return;

    var dt = stationarySince ? _parseUtcDate(stationarySince) : null;
    var mins = dt
        ? Math.max(0, Math.floor((Date.now() - dt.getTime()) / 60000))
        : 0;

    if (!stationarySince || mins < 15) {
        $content.html(
            '<div class="popup-fraud-ok">' +
                '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M10.8334 6.5C10.8334 8.89124 8.89131 10.8333 6.50008 10.8333C4.10885 10.8333 2.16675 8.89124 2.16675 6.5C2.16675 4.10876 4.10885 2.16666 6.50008 2.16666C8.89131 2.16666 10.8334 4.10876 10.8334 6.5Z" stroke="#16a34a" stroke-width="1.08333"/>' +
                '<path d="M4.33325 6.5L5.74992 7.91666L8.66659 5" stroke="#16a34a" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>' +
                "</svg> No issues detected</div>",
        );

        // Remove alert badge and restore icon colour from trigger
        var $section = $content.closest(".popup-section");
        $section
            .find("[data-popup-toggle] .popup-section__title")
            .css("color", "");
        $section.find("[data-popup-toggle] .popup-fraud-badge").remove();
        return;
    }

    var since = dt
        ? dt.getHours().toString().padStart(2, "0") +
          ":" +
          dt.getMinutes().toString().padStart(2, "0")
        : "";
    var minLabel = mins < 1 ? "just now" : mins + " min";

    $content.html(
        '<div class="popup-fraud-alert">' +
            '<div class="popup-fraud-alert__icon">&#9888;</div>' +
            "<div>" +
            '<div class="popup-fraud-alert__title">Driver Not Moving</div>' +
            '<div class="popup-fraud-alert__meta">Stationary for ' +
            minLabel +
            " &mdash; since " +
            since +
            "</div>" +
            "</div></div>",
    );

    // Open the section and show alert badge on trigger if not already there
    var $section = $content.closest(".popup-section");
    $section.addClass("popup-section--active");
    $section.find("[data-popup-toggle]").attr("aria-expanded", "true");
    $section
        .find("[data-popup-toggle] .popup-section__title")
        .css("color", "#b45309");
    if (!$section.find(".popup-fraud-badge").length) {
        $section
            .find("[data-popup-toggle] .popup-section__title")
            .after(
                '<span class="popup-fraud-badge" style="display:inline-flex;align-items:center;' +
                    "padding:1px 6px;background:#fef3c7;border:1px solid #fcd34d;border-radius:4px;" +
                    'font-size:9px;font-weight:700;color:#92400e;margin-left:4px;">&#9888; ALERT</span>',
            );
    }
}

function _updateLoadVehicle(loadId, location) {
    var ov = _loadOverlays[String(loadId)];
    if (!_activeMaps().length || !ov || !location || !location.lat || !location.lng)
        return;

    var position = {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lng),
    };
    if (ov.vehicle) {
        ov.vehicle.setPosition(position);
        return;
    }

    ov.vehicle = _multiMarker({
        position: position,
        title: "Last known position",
        icon: _makeTruckIcon(ov.color || "#3b82f6"),
        zIndex: 10,
    });
    ov.vehicle.addListener("click", function () {
        jQuery(
            '[data-popup-load-id="' +
                loadId +
                '"] [data-popup-toggle="device"]',
        )
            .first()
            .trigger("click");
    });
}

function _drawLoadLocationHistory(loadId, routeLocations) {
    var ov = _loadOverlays[String(loadId)];
    if (!_activeMaps().length || !ov) return;

    var path = (routeLocations || [])
        .filter(function (location) {
            return location.lat != null && location.lng != null;
        })
        .map(function (location) {
            return {
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng),
            };
        });

    if (path.length < 2) return;

    if (ov.trackPolyline) {
        ov.trackPolyline.setMap(null);
        ov.trackPolyline = null;
    }

    ov.trackPolyline = _multiPolyline({
        path: path,
        geodesic: true,
        strokeColor: ov.color || "#3b82f6",
        strokeOpacity: 0.95,
        strokeWeight: 3,
        zIndex: 20,
    });
}

function refreshActiveLoadData() {
    if (!_activeMaps().length) return;

    var ids = Object.keys(_loadOverlays);
    if (!ids.length) return;

    var $dashboard = jQuery("[data-dashboard-root]");
    if (!$dashboard.length) return;

    jQuery.ajax({
        url: $dashboard.data("ajaxUrl"),
        method: "POST",
        dataType: "json",
        data: {
            action: "load_track_live_data",
            _token: $dashboard.data("csrfToken"),
            ids: ids,
        },
        success: function (res) {
            if (!res.success) return;
            (res.loads || []).forEach(function (load) {
                if (load.location) {
                    _updatePopupLiveText(load.id, load.location);
                    _updateLoadVehicle(load.id, load.location);
                }
                if (load.route_locations && load.route_locations.length >= 2) {
                    _drawLoadLocationHistory(load.id, load.route_locations);
                }
                _updatePopupTrackingStatus(load.id, load.status);
                _updateSidebarPodAlert(load.id, !!load.pod_submitted);
                _updatePopupFraud(load.id, load.stationary_since || null);
                _updatePopupSpeed(load.id, load.current_speed_kmh);
                _updatePopupMoving(load.id, load.moving_since || null);
            });
        },
    });
}

function _updatePopupTrackingStatus(loadId, status) {
    var $el = _popupNodes(loadId).find("[data-popup-tracking-status]");
    if (!$el.length || !status) return;
    var isTracking = status === "tracking";
    $el.text(isTracking ? "Yes" : "No")
        .attr("data-popup-tracking-status", status)
        .toggleClass("popup-info-row__value--success", isTracking);
}

// Adds/removes the green "POD Pending Acceptance" strip on the sidebar card — the
// sidebar list itself is only rendered once (on page load or a search/filter
// action), unlike the popup which re-fetches fresh on every open, so without
// this a POD submitted while the dashboard is already open wouldn't show up
// here until the page was reloaded.
function _updateSidebarPodAlert(loadId, podSubmitted) {
    var $cards = jQuery('.load-card[data-load-id="' + loadId + '"]');
    if (!$cards.length) return;

    $cards.each(function () {
        var $card = jQuery(this);
        var $existing = $card.find(".load-card__pod-alert");
        if (podSubmitted && !$existing.length) {
            $card.append(
                '<div class="load-card__pod-alert">' +
                    '<svg width="12" height="12" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path d="M11.9167 6.01251V6.5C11.9159 7.66765 11.5357 8.80351 10.8339 9.73688C10.132 10.6702 9.14622 11.3505 8.02407 11.676C6.90191 12.0015 5.70449 11.9548 4.61123 11.5429C3.51796 11.131 2.58822 10.3762 1.9614 9.39182C1.33458 8.40745 1.04442 7.24625 1.13454 6.08201C1.22466 4.91778 1.6901 3.81478 2.46137 2.93852C3.23265 2.06226 4.26758 1.4551 5.41174 1.20732C6.55591 0.959537 7.74911 1.08434 8.81668 1.56308" stroke="#16a34a" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>' +
                    '<path d="M11.9167 2.16669L6.5 7.58877L4.875 5.96377" stroke="#16a34a" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>' +
                    "</svg>" +
                    "<span>POD Pending Acceptance</span>" +
                    "</div>",
            );
        } else if (!podSubmitted && $existing.length) {
            $existing.remove();
        }
    });
}

function _updatePopupSpeed(loadId, speedKmh) {
    var $el = _popupNodes(loadId).find("[data-popup-speed]");
    if (!$el.length) return;
    var label, color;
    if (speedKmh === null || speedKmh === undefined) {
        label = "—";
        color = "#aaa";
    } else if (speedKmh < 3) {
        label = "Stopped";
        color = "#aaa";
    } else {
        label = Math.round(speedKmh) + " km/h";
        color = "#22c55e";
    }
    $el.text(label).css("color", color);
}

function _updatePopupMoving(loadId, movingSince) {
    var $row = _popupNodes(loadId).find("[data-popup-moving]");
    if (!$row.length) return;

    var dt = movingSince ? _parseUtcDate(movingSince) : null;
    var mins = dt
        ? Math.max(0, Math.floor((Date.now() - dt.getTime()) / 60000))
        : 0;
    var isLongDrive = !!movingSince && mins >= 180;

    var label = !movingSince
        ? "—"
        : mins >= 60
          ? Math.floor(mins / 60) + "h " + (mins % 60) + "m"
          : mins + " min";
    var color = !movingSince ? "#aaa" : isLongDrive ? "#b45309" : "#22c55e";

    $row.text(label).css("color", color);
    _popupNodes(loadId)
        .find("[data-popup-long-drive-badge]")
        .css("display", isLongDrive ? "inline-flex" : "none");
}

function addLoadToMap(loadId, stops, location, routeLocations) {
    if (!_activeMaps().length) return;
    var key = String(loadId);
    if (_loadOverlays[key]) removeLoadFromMap(loadId);

    // Remove global dashboard pin so overlay vehicle marker is the only truck shown
    if (_pinMarkers[key]) {
        _pinMarkers[key].setMap(null);
        delete _pinMarkers[key];
    }

    var color = _routeColors[_routeColorIndex++ % _routeColors.length];
    var ov = { markers: [], polyline: null, geofences: [], color: color };
    _loadOverlays[key] = ov;

    stops.forEach(function (stop, i) {
        var pos = { lat: parseFloat(stop.lat), lng: parseFloat(stop.lng) };
        var label = i === 0 ? "A" : i === stops.length - 1 ? "B" : String(i);
        ov.markers.push(
            _multiMarker({
                position: pos,
                title: stop.address,
                label: { text: label, color: "#fff", fontWeight: "bold" },
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor:
                        i === 0
                            ? "#22c55e"
                            : i === stops.length - 1
                              ? "#ef4444"
                              : "#f59e0b",
                    fillOpacity: 1,
                    strokeColor: "#fff",
                    strokeWeight: 2,
                },
            }),
        );
    });

    var geofenceRadius =
        parseInt(jQuery("[data-dashboard-root]").data("geofenceRadius"), 10) ||
        1609;
    stops.forEach(function (stop) {
        if (!stop.lat || !stop.lng) return;
        ov.geofences.push(
            _multiCircle({
                center: {
                    lat: parseFloat(stop.lat),
                    lng: parseFloat(stop.lng),
                },
                radius: geofenceRadius,
                fillColor: color,
                fillOpacity: 0.12,
                strokeColor: color,
                strokeOpacity: 0.4,
                strokeWeight: 1.5,
            }),
        );
    });

    // Draw GPS track and vehicle marker first so _fitAllActiveBounds includes them
    if (routeLocations && routeLocations.length >= 2) {
        _drawLoadLocationHistory(loadId, routeLocations);
    }
    if (location && location.lat && location.lng) {
        _updateLoadVehicle(loadId, location);
    }

    _fitAllActiveBounds();

    var routeStops = stops.filter(function (s) {
        var lat = parseFloat(s.lat),
            lng = parseFloat(s.lng);
        return !isNaN(lat) && !isNaN(lng) && s.lat !== null && s.lng !== null;
    });
    if (routeStops.length >= 2) {
        var osrmCoords = routeStops
            .map(function (s) {
                return (
                    parseFloat(s.lng).toFixed(6) +
                    "," +
                    parseFloat(s.lat).toFixed(6)
                );
            })
            .join(";");

        fetch(
            "https://router.project-osrm.org/route/v1/driving/" +
                osrmCoords +
                "?overview=full&geometries=geojson",
        )
            .then(function (r) {
                return r.json();
            })
            .then(function (data) {
                if (!data.routes || !data.routes[0]) return;
                var roadPath = data.routes[0].geometry.coordinates.map(
                    function (c) {
                        return { lat: c[1], lng: c[0] };
                    },
                );
                var hasGps = routeLocations && routeLocations.length >= 2;
                ov.polyline = _multiPolyline({
                    path: roadPath,
                    geodesic: true,
                    strokeColor: color,
                    strokeOpacity: hasGps ? 0.2 : 0.85,
                    strokeWeight: hasGps ? 2 : 4,
                });
            })
            .catch(function () {});
    }
}

/** Mobile workspace — tab switching **/
jQuery(document).on("click", "[data-mobile-tab]", function () {
    var tab = jQuery(this).data("mobileTab");
    jQuery("[data-mobile-tab]").removeClass("is-active");
    jQuery(this).addClass("is-active");
    jQuery("[data-mobile-pane]").removeClass("is-active");
    jQuery('[data-mobile-pane="' + tab + '"]').addClass("is-active");

    if (tab === "map" && mapMobile) {
        setTimeout(function () {
            google.maps.event.trigger(mapMobile, "resize");
            if (Object.keys(_loadOverlays).length) {
                _fitAllActiveBounds();
            }
        }, 50);
    }
});

/** Mobile workspace — bottom sheet **/
function openMobileSheet(loadId, $card) {
    var $sheet = jQuery("[data-mobile-sheet]");
    var $backdrop = jQuery("[data-mobile-sheet-backdrop]");
    var $body = jQuery("[data-mobile-sheet-body]");
    var csrfToken = jQuery("[data-dashboard-root]").data("csrfToken");
    var ajaxUrl = jQuery("[data-dashboard-root]").data("ajaxUrl");

    jQuery(".workspace--mobile [data-load-id]").removeClass("is-active");
    if ($card && $card.length) {
        $card.addClass("is-active");
    }

    $body.html(
        '<div class="workspace-mobile__sheet-loading"><span>Loading…</span></div>',
    );
    $sheet.removeClass("is-minimized").addClass("is-open").data("activeLoadId", loadId);
    $backdrop.addClass("is-open");

    jQuery.ajax({
        url: ajaxUrl,
        method: "POST",
        dataType: "json",
        data: {
            action: "load_track_popup_data",
            id: loadId,
            _token: csrfToken,
        },
        success: function (res) {
            if (!res.success) {
                $body.html(
                    '<div class="workspace-mobile__sheet-loading"><span>' +
                        (res.message || "Could not load data.") +
                        "</span></div>",
                );
                return;
            }
            var $popup = jQuery(res.popup_html);
            $popup.addClass("is-opened");
            $body.empty().append($popup);

            if (res.map_stops && res.map_stops.length) {
                addLoadToMap(
                    loadId,
                    res.map_stops,
                    res.location || null,
                    res.route_locations || [],
                );
                refreshActiveLoadData();
            }
        },
        error: function () {
            $body.html(
                '<div class="workspace-mobile__sheet-loading"><span>Server error.</span></div>',
            );
        },
    });
}

function minimizeMobileSheet() {
    jQuery("[data-mobile-sheet]").addClass("is-minimized");
    jQuery("[data-mobile-sheet-backdrop]").removeClass("is-open");
    jQuery('[data-mobile-tab="map"]').trigger("click");
}

function expandMobileSheet() {
    jQuery("[data-mobile-sheet]").removeClass("is-minimized");
    jQuery("[data-mobile-sheet-backdrop]").addClass("is-open");
}

function closeMobileSheet() {
    var $sheet = jQuery("[data-mobile-sheet]");
    var loadId = $sheet.data("activeLoadId");
    $sheet.removeClass("is-open is-minimized").removeData("activeLoadId");
    jQuery("[data-mobile-sheet-backdrop]").removeClass("is-open");
    jQuery(".workspace--mobile [data-load-id]").removeClass("is-active");
    if (loadId) {
        removeLoadFromMap(loadId);
    }
}

jQuery(document).on("click", "[data-mobile-sheet-backdrop]", function () {
    closeMobileSheet();
});

jQuery(document).on("click", "[data-mobile-sheet] .workspace-mobile__sheet-handle", function () {
    if (jQuery("[data-mobile-sheet]").hasClass("is-minimized")) {
        expandMobileSheet();
    }
});

jQuery(document).on("click", "[data-load-id]", function () {
    var $card = jQuery(this);
    var loadId = $card.data("loadId");

    if (isMobile()) {
        openMobileSheet(loadId, $card);
        return;
    }

    var csrfToken = jQuery("[data-dashboard-root]").data("csrfToken");
    var ajaxUrl = jQuery("[data-dashboard-root]").data("ajaxUrl");

    $card.addClass("is-active");

    var $existing = jQuery(
        ".workspace__map-loads [data-popup-load-id='" + loadId + "']",
    );
    if ($existing.length) {
        jQuery(".workspace__map-loads .load-card-popup").removeClass(
            "is-opened",
        );
        $existing.addClass("is-opened");
        if (!_loadOverlays[String(loadId)]) {
            var cachedStops = $existing.data("mapStops");
            var cachedLoc = $existing.data("mapLocation") || null;
            var cachedRoute = $existing.data("routeLocations") || [];
            if (cachedStops && cachedStops.length) {
                addLoadToMap(loadId, cachedStops, cachedLoc, cachedRoute);
            }
        }
        refreshActiveLoadData();
        return;
    }

    jQuery.ajax({
        url: ajaxUrl,
        method: "POST",
        dataType: "json",
        data: {
            action: "load_track_popup_data",
            id: loadId,
            _token: csrfToken,
        },
        success: function (res) {
            if (!res.success) {
                showAppNotice(
                    res.message || "Could not load popup data.",
                    "error",
                );
                return;
            }

            jQuery(".workspace__map-loads .load-card-popup").removeClass(
                "is-opened",
            );
            var $popup = jQuery(res.popup_html);
            $popup.data("mapStops", res.map_stops || []);
            $popup.data("mapLocation", res.location || null);
            $popup.data("routeLocations", res.route_locations || []);
            jQuery(".workspace__map-loads").prepend($popup);

            if (res.map_stops && res.map_stops.length) {
                addLoadToMap(
                    loadId,
                    res.map_stops,
                    res.location || null,
                    res.route_locations || [],
                );
                refreshActiveLoadData();
            } else {
                showAppNotice("No mappable stops for this load.", "error");
            }
        },
        error: function () {
            showAppNotice(
                "A server error occurred loading popup data.",
                "error",
            );
        },
    });
});

/** Driver password confirmation **/
jQuery(document).on("submit", "form[action='/ajax']", function (e) {
    var $form = jQuery(this);
    var $pw = $form.find("[name='password']");
    var $pw2 = $form.find("[name='password_confirm']");
    if (!$pw.length || !$pw2.length) return;
    if ($pw.val() === "" && $pw2.val() === "") return;
    if ($pw.val() !== $pw2.val()) {
        e.stopImmediatePropagation();
        showAppNotice("Passwords do not match.", "error");
    }
});

/** Mobile menu **/
jQuery(document).on("click", "[data-mobile-menu-toggle]", function (e) {
    e.stopPropagation();
    jQuery(this).closest("[data-mobile-menu]").addClass("is-open");
    jQuery(this).attr("aria-expanded", "true");
    jQuery("body").addClass("mobile-menu-open");
});

jQuery(document).on(
    "click",
    "[data-mobile-menu-close], [data-mobile-menu-backdrop]",
    function () {
        var $menu = jQuery(this).closest("[data-mobile-menu]");
        $menu.removeClass("is-open");
        $menu.find("[data-mobile-menu-toggle]").attr("aria-expanded", "false");
        jQuery("body").removeClass("mobile-menu-open");
    },
);

/** User menu toggle **/
jQuery(document).on("click", "[data-user-menu-toggle]", function (e) {
    e.stopPropagation();
    var $panel = jQuery(this)
        .closest("[data-user-menu]")
        .find("[data-user-menu-panel]");
    var isOpen = !$panel.attr("hidden");
    jQuery("[data-notif-panel]").attr("hidden", "");
    jQuery("[data-notif-toggle]").attr("aria-expanded", "false");
    if (isOpen) {
        $panel.attr("hidden", "");
        jQuery(this).attr("aria-expanded", "false");
    } else {
        $panel.removeAttr("hidden");
        jQuery(this).attr("aria-expanded", "true");
    }
});

jQuery(document).on("click", function (e) {
    if (!jQuery(e.target).closest("[data-user-menu]").length) {
        jQuery("[data-user-menu-panel]").attr("hidden", "");
        jQuery("[data-user-menu-toggle]").attr("aria-expanded", "false");
    }
});

/** Logout **/
jQuery(document).on("click", "[data-app-logout]", function () {
    var $root = jQuery("[data-dashboard-root]");
    var csrfToken =
        $root.data("csrfToken") ||
        jQuery("input[name='_token']").first().val() ||
        jQuery("meta[name='csrf-token']").attr("content") ||
        "";
    var ajaxUrl = $root.data("ajaxUrl") || "/ajax";
    jQuery.ajax({
        url: ajaxUrl,
        method: "POST",
        dataType: "json",
        data: { action: "logout", _token: csrfToken },
        complete: function () {
            window.location.href = "/login";
        },
    });
});

/** Notifications **/
(function () {
    function notifAjaxUrl() {
        var $root = jQuery("[data-dashboard-root]");
        return $root.data("ajaxUrl") || "/ajax";
    }

    function notifCsrfToken() {
        var $root = jQuery("[data-dashboard-root]");
        return (
            $root.data("csrfToken") ||
            jQuery("input[name='_token']").first().val() ||
            jQuery("meta[name='csrf-token']").attr("content") ||
            ""
        );
    }

    function escapeHtml(str) {
        return jQuery("<div>")
            .text(str || "")
            .html();
    }

    function timeAgo(dateStr) {
        var date = new Date(String(dateStr).replace(" ", "T") + "Z");
        var seconds = Math.floor((Date.now() - date.getTime()) / 1000);
        if (seconds < 60) return "just now";
        var minutes = Math.floor(seconds / 60);
        if (minutes < 60) return minutes + "m ago";
        var hours = Math.floor(minutes / 60);
        if (hours < 24) return hours + "h ago";
        var days = Math.floor(hours / 24);
        return days + "d ago";
    }

    function updateBadge(count) {
        var $badge = jQuery("[data-notif-badge]");
        if (count > 0) {
            $badge.text(count > 9 ? "9+" : count).removeAttr("hidden");
        } else {
            $badge.attr("hidden", "");
        }
    }

    function renderNotifications(notifications) {
        var $list = jQuery("[data-notif-list]");
        if (!notifications.length) {
            $list.html(
                '<div class="tracking-notifications__empty">No notifications yet.</div>',
            );
            return;
        }
        var html = notifications
            .map(function (n) {
                var unreadClass =
                    Number(n.is_read) === 0
                        ? " tracking-notifications__item--unread"
                        : "";
                var href = n.link_url || "#";
                return (
                    '<div class="tracking-notifications__item' +
                    unreadClass +
                    '">' +
                    '<a class="tracking-notifications__item-body" href="' +
                    escapeHtml(href) +
                    '" data-notif-id="' +
                    n.id +
                    '">' +
                    '<div class="tracking-notifications__item-title">' +
                    escapeHtml(n.title) +
                    "</div>" +
                    '<div class="tracking-notifications__item-message">' +
                    escapeHtml(n.message) +
                    "</div>" +
                    '<div class="tracking-notifications__item-time">' +
                    timeAgo(n.created_at) +
                    "</div>" +
                    "</a>" +
                    '<button type="button" class="tracking-notifications__item-delete" data-notif-delete data-notif-delete-id="' +
                    n.id +
                    '" aria-label="Delete notification" title="Delete">&times;</button>' +
                    "</div>"
                );
            })
            .join("");
        $list.html(html);
    }

    function loadNotifications() {
        jQuery.ajax({
            url: notifAjaxUrl(),
            method: "POST",
            dataType: "json",
            data: { action: "notifications_list", _token: notifCsrfToken() },
            success: function (res) {
                if (res && res.success) {
                    renderNotifications(res.notifications || []);
                    updateBadge(res.unread_count || 0);
                }
            },
        });
    }

    jQuery(document).on("click", "[data-notif-toggle]", function (e) {
        e.stopPropagation();
        var $panel = jQuery(this)
            .closest("[data-notif-menu]")
            .find("[data-notif-panel]");
        var isOpen = !$panel.attr("hidden");
        jQuery("[data-user-menu-panel]").attr("hidden", "");
        jQuery("[data-user-menu-toggle]").attr("aria-expanded", "false");
        if (isOpen) {
            $panel.attr("hidden", "");
            jQuery(this).attr("aria-expanded", "false");
        } else {
            $panel.removeAttr("hidden");
            jQuery(this).attr("aria-expanded", "true");
            loadNotifications();
        }
    });

    jQuery(document).on("click", function (e) {
        if (!jQuery(e.target).closest("[data-notif-menu]").length) {
            jQuery("[data-notif-panel]").attr("hidden", "");
            jQuery("[data-notif-toggle]").attr("aria-expanded", "false");
        }
    });

    jQuery(document).on("click", "[data-notif-mark-all]", function (e) {
        e.preventDefault();
        e.stopPropagation();
        jQuery.ajax({
            url: notifAjaxUrl(),
            method: "POST",
            dataType: "json",
            data: {
                action: "notifications_mark_read",
                _token: notifCsrfToken(),
            },
            success: loadNotifications,
        });
    });

    jQuery(document).on("click", "[data-notif-id]", function () {
        var id = jQuery(this).data("notifId");
        jQuery.ajax({
            url: notifAjaxUrl(),
            method: "POST",
            dataType: "json",
            data: {
                action: "notifications_mark_read",
                _token: notifCsrfToken(),
                id: id,
            },
        });
    });

    jQuery(document).on("click", "[data-notif-delete]", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = jQuery(this).data("notifDeleteId");
        var $item = jQuery(this).closest(".tracking-notifications__item");
        jQuery.ajax({
            url: notifAjaxUrl(),
            method: "POST",
            dataType: "json",
            data: {
                action: "notifications_delete",
                _token: notifCsrfToken(),
                id: id,
            },
            success: function (res) {
                if (res && res.success) {
                    $item.fadeOut(150, function () {
                        jQuery(this).remove();
                        if (!jQuery("[data-notif-list] .tracking-notifications__item").length) {
                            jQuery("[data-notif-list]").html(
                                '<div class="tracking-notifications__empty">No notifications yet.</div>',
                            );
                        }
                    });
                    updateBadge(res.unread_count || 0);
                }
            },
        });
    });

    // script.min.js loads via a blocking <script> tag in <head>, before
    // <body> (and the notification bell markup) has been parsed — running
    // this check immediately always found zero elements, so the badge only
    // ever populated once the user clicked the bell (which loads on its own
    // delegated handler, unaffected by DOM-readiness timing). Deferring to
    // DOMContentLoaded fixes the initial badge/count and the 60s polling.
    jQuery(function () {
        if (jQuery("[data-notif-menu]").length) {
            loadNotifications();
            setInterval(loadNotifications, 60000);
        }
    });
})();
